// PPFE-0016
export const PPFE_0016_TREATMENT_KEY = 'ppfe-0016';
export const PPFE_0016_GROUP_PARAMETER_KEY = 'group';
export let PPFE_0016_GROUP_PARAMETER_OPTIONS;
(function (PPFE_0016_GROUP_PARAMETER_OPTIONS) {
  PPFE_0016_GROUP_PARAMETER_OPTIONS["control"] = "control";
  PPFE_0016_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(PPFE_0016_GROUP_PARAMETER_OPTIONS || (PPFE_0016_GROUP_PARAMETER_OPTIONS = {}));